export class A11yToggle {
  target?: HTMLElement;
  toggle?: HTMLElement;
  visible: boolean = false;

  constructor() {
    this.toggle = document.querySelector<HTMLElement>('[data-ally-toggle]') ?? undefined;
    this.target = document.querySelector<HTMLElement>('.a11y-toolbar') ?? undefined;

    this.bindEvents();
  }

  bindEvents() {
    if (!this.toggle || !this.target) {
      return;
    }

    this.visible = this.toggle.dataset.allyToggle === '1';

    this.toggle.addEventListener('click', () => {
      if (!this.toggle || !this.target) {
        return;
      }
      this.visible = !this.visible;
      this.toggle.dataset.allyToggle = this.visible ? '1' : '0';
      const style = this.visible ? 'block' : 'none';
      this.target.style.display = style;
    });
  }
}
